import { FunctionButton } from '@pulse-web-ui/button-v2';
import { styled } from '@pulse-web-ui/theme';

export const NumberLabel = styled.span<{ $isNewPath?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${({ theme, $isNewPath }) =>
    $isNewPath ? theme.colors.neutral['100'] : theme.colors.surface.brand};
  color: ${({ theme }) => theme.colors['on-accent'].primary};
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const RemoveButton = styled(FunctionButton)`
  color: ${({ theme }) => theme.colors.text.error};
`;
